import appActions from 'store/app/actions';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import React from 'react';

const Name = ({ toggleHover }) => (
  <div className="nameWrapper" onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
    <svg xmlns="http://www.w3.org/2000/svg">
      <rect className="border" />
    </svg>
    <h1 className="name">Pedro Restrepo</h1>
  </div>
);
Name.propTypes = {
  toggleHover: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  toggleHover: () => dispatch(appActions.toogleHoverName()),
});

export default connect(
  null,
  mapDispatchToProps,
)(Name);
